import moment from "moment";

export const formatGiftDashboardDate = (createdAt: number) =>
    moment.unix(createdAt / 1000).format("MM/DD/YYYY");

export const formatGiftDashboardDateTime = (createdAt: number) =>
    moment.unix(createdAt / 1000).format("MM/DD/YYYY h:mm A");
